export default __webpack_public_path__ + "static/media/psychologyOfMoney.8957625b.jpg";